import {initAlpine} from "./init";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import {SplitText} from "./SplitText.js";
import {stickNavbar} from "./features/stickyNavigation.js";
import {heroMasterAnimation} from "./heroAnim.js";
import {locationGallerySwiper} from "./features/gallerySwiper.js";
import {timelineAnimation} from "./features/timeline.js";
// register GSAP
gsap.registerPlugin( ScrollTrigger );
gsap.registerPlugin(SplitText);

// create a reusable effect that swaps text
gsap.registerEffect({
    name: "swapText",
    effect: (targets, config) => {
        let tl = gsap.timeline({delay: config.delay});
        tl.to(targets, {opacity: 0, duration: config.duration / 2});
        tl.add(() => targets[0].innerText = config.text);
        tl.to(targets, {opacity: 1, duration: config.duration});
        return tl;
    },
    defaults: {duration: 1},
    extendTimeline: true
});

// !!!!!!!!! Keep this Alpine init at the end !!!!!!!!!
window.Webflow ||= [];
window.Webflow.push(() => {
    document.body.style.overflow = "hidden";
    initAlpine();
    Webflow.require('lottie').lottie.getRegisteredAnimations().find(animation => animation.fileName.includes("wayin-hand-01")).stop();
    Webflow.require('lottie').lottie.getRegisteredAnimations().find(animation => animation.fileName.includes("wayin-hand-02")).stop();
    heroMasterAnimation();
    locationGallerySwiper();
    stickNavbar();

    window.onload = function() {
        timelineAnimation('.section.is-setting-up .timeline-screen');
        document.body.style.overflow = "auto";
        ScrollTrigger.refresh();
    };

});